import type { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { AUTO_COL_WIDTH } from '~/components2/Table';
import type { UtilityContact } from '../common';

export const columns: ColumnDef<UtilityContact>[] = [
  {
    id: 'agencyName',
    header: 'Agency Name',
    accessorKey: 'agencyName',
    size: AUTO_COL_WIDTH,
  },
  {
    id: 'agencyType',
    header: 'Agency Type',
    accessorKey: 'agencyType',
  },
  {
    id: 'contact',
    header: 'Contact',
    accessorKey: 'contacts',
    cell: ({ cell }) => (
      <div>
        {(cell.getValue() as { name: string; email: string }[])?.map((contact) => (
          <React.Fragment key={contact.email}>
            <a href={`mailto:${contact.email}`}>{contact.name}</a> <br />
          </React.Fragment>
        ))}
      </div>
    ),
    size: AUTO_COL_WIDTH,
  },
];
